import { render, staticRenderFns } from "./ChooseDoctor.vue?vue&type=template&id=afe909ea&scoped=true&"
import script from "./ChooseDoctor.vue?vue&type=script&lang=js&"
export * from "./ChooseDoctor.vue?vue&type=script&lang=js&"
import style0 from "./ChooseDoctor.vue?vue&type=style&index=0&id=afe909ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe909ea",
  null
  
)

export default component.exports